import React, { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
//@ts-ignore
import styles from './Select.module.scss?module';

type SelectPropsT = React.SelectHTMLAttributes<HTMLSelectElement> & {
  children?: ReactNode;
};

export const Select = forwardRef<HTMLSelectElement, SelectPropsT>(
  ({ children, className, ...props }, ref) => {
    return (
      <select
        ref={ref}
        className={`${styles.Select} ${className || ''}`}
        name={props.name || props.value?.toString() || 'select Element'}
        {...props}
      >
        {children}
      </select>
    );
  }
);

Select.displayName = 'Select';

type OptionPropsT = React.OptionHTMLAttributes<HTMLOptionElement> & {
  children?: ReactNode;
};

export const Option = forwardRef<HTMLOptionElement, OptionPropsT>(
  ({ children, className, ...props }, ref) => {
    return (
      <option
        ref={ref}
        className={`${styles.Option} ${className || ''}`}
        {...props}
      >
        {children}
      </option>
    );
  }
);
